module.exports = __webpack_public_path__ + "static/media/whittington-cars.a49416ef.jpg";